// extracted by mini-css-extract-plugin
export default {"error":"error__jztBL","header":"header__8+cPf","info":"info__rBWr3"};